import React from 'react'
import {Control} from 'react-redux-form'
import {Row, Col, FormControl} from 'react-bootstrap'
import SectionTitle from '../../common/section-title'

const OrderSummary = () => {
  return (
    <div>
      <SectionTitle>summary</SectionTitle>
      <Col lg={12}>
        <Row>
          <div>Your reference</div>
          <Control.text
            model=".your_reference"
            component={FormControl}/>
        </Row>
      </Col>
    </div>
  )
};

export default OrderSummary



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/order-summary.jsx